import React from 'react';
import { Zap, Leaf, Wind, Building } from 'lucide-react';
export function BusinessModel() {
  const streams = [{
    title: 'Electricity Sales',
    value: '$0.10–$0.12',
    unit: 'per kWh',
    icon: Zap,
    description: 'Direct sales to grid or industrial partners via Power Purchase Agreements.'
  }, {
    title: 'Bio-Fertilizer',
    value: '$350–$400',
    unit: 'per tonne',
    icon: Leaf,
    description: 'High-quality agricultural byproduct sold to local farming operations.'
  }, {
    title: 'Carbon Credits',
    value: 'Market Rate',
    unit: 'per tonne CO2e',
    icon: Wind,
    description: 'Monetizing verified emissions reductions on voluntary and compliance markets.'
  }, {
    title: 'Municipal Contracts',
    value: 'Tipping Fees',
    unit: 'per tonne waste',
    icon: Building,
    description: 'Revenue from processing organic waste diverted from traditional landfills.'
  }];
  return <section className="py-20 bg-slate-950 border-t border-slate-900" data-id="element-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7">
        <div className="text-center mb-16" data-id="element-8">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-9">
            Multiple Revenue Streams
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-10">
            Our circular model creates diversified, resilient cash flows from
            both the input (waste) and output (energy/products) sides of the
            operation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-11">
          {streams.map((stream, index) => {
          const Icon = stream.icon;
          return <div key={index} className="flex flex-col sm:flex-row gap-6 p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-emerald-500/30 transition-colors" data-id="element-12">
                <div className="w-16 h-16 rounded-2xl bg-slate-800 flex items-center justify-center shrink-0" data-id="element-13">
                  <Icon className="w-8 h-8 text-emerald-400" data-id="element-14" />
                </div>
                <div data-id="element-15">
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-16">
                    {stream.title}
                  </h3>
                  <div className="flex items-baseline gap-2 mb-3" data-id="element-17">
                    <span className="text-2xl font-extrabold text-emerald-400" data-id="element-18">
                      {stream.value}
                    </span>
                    <span className="text-sm text-slate-500 font-medium" data-id="element-19">
                      {stream.unit}
                    </span>
                  </div>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-20">
                    {stream.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}